import React from 'react'

import Alert from '@material-ui/lab/Alert'
import { makeStyles } from '@material-ui/core/styles'
const useStyles = makeStyles((theme) => ({
  root: {
    [theme.breakpoints.up('xl')]: {
      fontSize: '1.5em',
    },
    '& svg': {
      fontSize: '1.5em',
    },
  },
}))
const OlcuAlert = () => {
  const classes = useStyles()
  return (
    <Alert severity='warning' className={classes.root}>
      Aşağıdaki hasır tel ölçüleri örnek ölçülerdir. Sadece fikir vermek için yazılmıştır. İhtiyacınıza göre istediğiniz her ölçüde hasır
      tel imalatı yapılmaktadır.
    </Alert>
  )
}
export default OlcuAlert
